import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { HybridRegionTypeCardFragment } from "../../client/generated";
import { RegionTypeCard } from "../RegionTypeCard";
import { useTranslation } from "react-i18next";

type Props = {
  fragment: HybridRegionTypeCardFragment;
  dispatch: Dispatch<EditorAction>;
};

export function HybridRegionTypeCard({ fragment, dispatch }: Props) {
  const { t } = useTranslation();

  const onConvert = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "hybrid",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTypeCard
      title={t("HybridRegionTypeCard.title")}
      description={t("HybridRegionTypeCard.description")}
      onConvert={onConvert}
    />
  );
}
